import styled from 'styled-components';
import { CDN_URL } from '@karma/utils/constants/env';

export const Container = styled.section`
  min-height: 470px;
  padding-bottom: 65px;
  padding-top: 175px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${CDN_URL}/images/karma/images/hero_background.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
